<template>
  <div class="main-content">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="content-wrapper">
      <div class="card-item">
        <div class="card-item-header">
          <label slot="header" class="card-item-title">{{$t("_EDIT_USER.INFO")}}</label>
        </div>
        <div class="card-item">
          <v-tabs v-model="currentTabIndex" background-color="transparent" class="main-tab-wrapper">
            <v-tab
              v-for="tabItem in tabs"
              :key="tabItem.index"
              :disabled="tabItem.disabled"
            >{{ tabItem.label }}</v-tab>
          </v-tabs>
          <div v-if="currentTabIndex === 0" class="mt-3">
            <div class="card-item-content pt-0">
              <v-row>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.USERNAME") + $t("REQUIRED")}}</label>
                  <input-text
                    maxlength="50"
                    :regex="REGEX_USERNAME"
                    :isLowerCase="true"
                    :disabled="isEdit"
                    :model.sync="data.userName"
                    :error.sync="error.userName.error"
                  />
                </v-col>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.FULLNAME") + $t("REQUIRED")}}</label>
                  <input-text
                    :model.sync="data.fullName"
                    :error.sync="error.fullName.error"
                    maxlength="255"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.GENDER")}}</label>
                  <v-radio-group v-model="data.gender" row class="input-gender">
                    <v-radio color="#173d8f" :label="$t('_EDIT_USER.GENDER_MALE')" :value="1"></v-radio>
                    <v-radio color="#173d8f" :label="$t('_EDIT_USER.GENDER_FEMALE')" :value="0"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.EMAIL") + $t("REQUIRED")}}</label>
                  <input-text
                    type="email"
                    :model.sync="data.email"
                    :error.sync="error.email.error"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.PHONE_NUMBER") + $t("REQUIRED")}}</label>
                  <input-text
                    :regex="REGEX_PHONE"
                    :model.sync="data.phoneNumber"
                    :error.sync="error.phoneNumber.error"
                  />
                </v-col>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.ADDRESS")}}</label>
                  <input-text
                    :model.sync="data.address"
                    :error.sync="error.address.error"
                    maxlength="255"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.POSITION")}}</label>
                  <input-text
                    :model.sync="data.position"
                    :error.sync="error.position.error"
                    maxlength="50"
                  />
                </v-col>
                <v-col cols="6">
                  <label class="label-input">{{$t("_EDIT_USER.GROUP")}} *</label>
                  <!-- Error case: input: (error.userGroup && error.userGroup.error) ? 'search-input is-error' : 'search-input', -->
                  <vue-single-select
                    :placeholder="$t('_EDIT_USER.GROUP_PLACEHOLDER')"
                    v-model="selectedUserGroup"
                    :options="listGroup"
                    option-label="groupName"
                    :required="error.userGroup.error"
                    @input.native="remoteFilterUserGroup"
                    :classes="{
                      input: 'search-input',
                      wrapper: 'single-select-wrapper',
                      icons: 'icons glyphicon',
                      required: 'required'
                    }"
                  ></vue-single-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                    v-model="data.owner"
                    color="#173d8f"
                    class="main-checkbox-no-text mt-0 pt-0"
                    :label="$t('_EDIT_USER.HOTEL_OWNER')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    :disabled="isCurrentUser"
                    v-model="data.active"
                    color="#173d8f"
                    class="main-checkbox-no-text mt-0 pt-0"
                    :label="$t('_EDIT_USER.STATUS')"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <button @click="back" class="main-btn btn-secondary mr-3">{{$t('BACK')}}</button>
                  <button @click="validateUser" class="main-btn btn-pmirary">{{$t('SAVE')}}</button>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-if="currentTabIndex === 1" class="mt-3">
            <table class="role-container">
              <thead>
                <tr>
                  <th class="column-1 text-center">{{$t('_EDIT_USER.NO')}}</th>
                  <th class="column-2">{{$t('_EDIT_USER.FUNCTION_CODE')}}</th>
                  <th>{{$t('_EDIT_USER.FUNCTION_NAME')}}</th>
                  <th class="column-4 text-center">{{$t('_EDIT_USER.ACTION')}}</th>
                </tr>
              </thead>
              <tbody>
                <!-- Level 1 -->
                <template v-for="(role, index) in roles">
                  <tr :key="role.id">
                    <td class="level-1 text-center">{{index + 1}}</td>
                    <td class="level-1">
                      <v-icon
                        v-if="role.child && role.child.length > 0 && role.showed"
                        @click="role.showed = false"
                        class="cell-icon"
                      >arrow_drop_up</v-icon>
                      <v-icon
                        v-if="role.child && role.child.length > 0 && !role.showed"
                        @click="role.showed = true"
                        class="cell-icon"
                      >arrow_drop_down</v-icon>
                      <strong>{{role.fnCode}}</strong>
                    </td>
                    <td class="level-1">{{$t('_ROLES.' + role.fnName)}}</td>
                    <td class="level-1 text-center">
                      <v-checkbox
                        :disabled="role.disabled"
                        v-model="role.checked"
                        @change="toggleAll(role)"
                        color="#173d8f"
                        class="main-checkbox-no-text justify-center mt-0 pt-0"
                      />
                    </td>
                  </tr>
                  <template v-if="role.showed">
                    <!-- Level 2 -->
                    <template v-for="(roleChild) in role.child">
                      <tr :key="roleChild.id">
                        <td class="level-2 text-center"></td>
                        <td class="level-2 child">
                          <v-icon
                            v-if="roleChild.child && roleChild.child.length > 0 && roleChild.showed"
                            @click="roleChild.showed = false; _forceUpdate()"
                            class="cell-icon"
                          >arrow_drop_up</v-icon>
                          <v-icon
                            v-if="roleChild.child && roleChild.child.length > 0 && !roleChild.showed"
                            @click="roleChild.showed = true; _forceUpdate()"
                            class="cell-icon"
                          >arrow_drop_down</v-icon>
                          <strong>{{roleChild.fnCode}}</strong>
                        </td>
                        <td class="level-2 child">{{$t('_ROLES.' + roleChild.fnName)}}</td>
                        <td class="level-2 text-center">
                          <v-checkbox
                            :disabled="roleChild.disabled"
                            v-model="roleChild.checked"
                            @change="toggleAll(roleChild, [role])"
                            color="#173d8f"
                            class="main-checkbox-no-text justify-center mt-0 pt-0"
                          />
                        </td>
                      </tr>
                      <template v-if="roleChild.showed">
                        <!-- Level 3 -->
                        <template v-for="(roleGrandChild) in roleChild.child">
                          <tr :key="roleGrandChild.id">
                            <td class="level-3 text-center"></td>
                            <td class="level-3 child">
                              <v-icon
                                v-if="roleGrandChild.child && roleGrandChild.child.length > 0 && roleGrandChild.showed"
                                @click="roleGrandChild.showed = false; _forceUpdate()"
                                class="cell-icon"
                              >arrow_drop_up</v-icon>
                              <v-icon
                                v-if="roleGrandChild.child && roleGrandChild.child.length > 0 && !roleGrandChild.showed"
                                @click="roleGrandChild.showed = true; _forceUpdate()"
                                class="cell-icon"
                              >arrow_drop_down</v-icon>
                              <strong>{{roleGrandChild.fnCode}}</strong>
                            </td>
                            <td class="level-3 child">{{$t('_ROLES.' + roleGrandChild.fnName)}}</td>
                            <td class="level-3 text-center">
                              <v-checkbox
                                :disabled="roleGrandChild.disabled"
                                v-model="roleGrandChild.checked"
                                @change="toggleAll(roleGrandChild, [roleChild, role])"
                                color="#173d8f"
                                class="main-checkbox-no-text justify-center mt-0 pt-0"
                              />
                            </td>
                          </tr>
                          <template v-if="roleGrandChild.showed">
                            <!-- Level 4 -->
                            <template v-for="(greatGrandChild) in roleGrandChild.child">
                              <tr :key="greatGrandChild.id">
                                <td class="level-4 text-center"></td>
                                <td class="level-4 child">
                                  <v-icon
                                    v-if="greatGrandChild.child && greatGrandChild.child.length > 0 && greatGrandChild.showed"
                                    @click="roleGrandChild.showed = false; _forceUpdate()"
                                    class="cell-icon"
                                  >arrow_drop_up</v-icon>
                                  <v-icon
                                    v-if="greatGrandChild.child && greatGrandChild.child.length > 0 && !greatGrandChild.showed"
                                    @click="greatGrandChild.showed = true; _forceUpdate()"
                                    class="cell-icon"
                                  >arrow_drop_down</v-icon>
                                  <strong>{{greatGrandChild.fnCode}}</strong>
                                </td>
                                <td class="level-4 child">{{$t('_ROLES.' + greatGrandChild.fnName)}}</td>
                                <td class="level-4 text-center">
                                  <v-checkbox
                                    :disabled="greatGrandChild.disabled"
                                    v-model="greatGrandChild.checked"
                                    @change="toggleAll(greatGrandChild, [roleGrandChild, roleChild, role])"
                                    color="#173d8f"
                                    class="main-checkbox-no-text justify-center mt-0 pt-0"
                                  />
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </tbody>
            </table>
            <div class="card-item-content">
              <v-row>
                <v-col cols="12" class="text-right">
                  <button @click="back" class="main-btn btn-secondary mr-3">{{$t('BACK')}}</button>
                  <button @click="updateUserRole" class="main-btn btn-pmirary">{{$t('SAVE')}}</button>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-tab-wrapper {
  margin-left: 20px;
  padding-left: 0;
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.column-1 {
  width: 5rem;
}
.column-2 {
  width: 15rem;
}
.column-4 {
  width: 7rem;
}
</style>

<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import VueSingleSelect from "vue-single-select";
import { getMuError } from "@/_helpers/config.js";
import { REGEX_PHONE, REGEX_USERNAME } from "@/_helpers/constant.js";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";
import { authenticationService } from "@/_services";
const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

export default {
  components: {
    "input-text": Input,
    "select-text": Select,
    VueSingleSelect
  },
  data() {
    return {
      isLoading: false,
      isEdit: false,
      isCurrentUser: false,
      currentTabIndex: null,
      tabs: [
        { index: 0, disabled: false, label: this.$t("_EDIT_USER.USER") },
        { index: 1, disabled: false, label: this.$t("_EDIT_USER.ROLE") }
      ],
      data: {
        gender: 1,
        active: true
      },
      currentUserRole: [],
      currentUserGroupRole: [],
      selectedUserGroup: null,
      listGroup: [],
      listAllGroups: [],
      error: getMuError(),
      roles: []
    };
  },
  computed: {
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_USERNAME() {
      return REGEX_USERNAME;
    }
  },
  watch: {
    selectedUserGroup: function(val) {
      // if (!val) {
      //   this.listGroup = [];
      // }
      this.listGroup = [...this.listAllGroups];
      this.getCurrentUserGroupRole();
    }
    // roles: {
    //   handler(value) {
    //     // console.log(value);
    //     value.forEach(x => {
    //       x.child.forEach(child => {
    //         child.checked = x.checked;
    //         child.child.forEach(grandChild => {
    //           grandChild.checked = child.checked;
    //         });
    //       });
    //     });
    //   },
    //   deep: true
    // }
  },
  created() {
    this.initialize();
  },
  async mounted() {
    await service.getAllActiveUserGroup({ name: "" }).then(res => {
      this.listAllGroups = res.data;
    });
    if (!this.data.userGroupId) {
      this.listGroup = [...this.listAllGroups];
    }
  },
  methods: {
    // Run when start
    initialize() {
      let requests = [];
      if (this.$route.params && this.$route.params.id) {
        this.isEdit = true;
        this.data.userName = this.$route.params.id;
        this.isCurrentUser =
          currentUser.user && currentUser.user.username === this.data.userName;
        requests.push(this.getUserDetail(this.data.userName));
        requests.push(this.getUserRole(this.data.userName));
      } else {
        this.tabs[1].disabled = true;
      }
      requests.push(this.getAllRole());
      this.isLoading = true;
      Promise.all(requests)
        .then(res => {
          if (this.isEdit) {
            // Find group name from group id, then search group by group name, populated result to select list (remote search)
            this.getGroupDetail(this.data.userGroupId).then(() => {
              if (this.selectedUserGroup) {
                this.searchGroupByName(this.selectedUserGroup.groupName);
              }
            });
            // Load roles checked state
            const checkedRolesId = this.currentUserRole.map(role => role.id);
            for (let role of this.roles) {
              this.checkRole(checkedRolesId, role);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // load role state (recursive)
    checkRole(checkedRolesId, role) {
      if (checkedRolesId.indexOf(role.id) > -1) {
        role.checked = true;
      } else {
        role.checked = false;
      }
      if (role.child && role.child.length > 0) {
        for (let child of role.child) {
          this.checkRole(checkedRolesId, child);
        }
      }
    },
    // Check and disabled role (recursive)
    disableRole(disableRolesId, role) {
      if (disableRolesId.indexOf(role.id) > -1) {
        role.checked = true;
        role.disabled = true;
      } else {
        role.disabled = false;
      }
      if (role.child && role.child.length > 0) {
        for (let child of role.child) {
          this.disableRole(disableRolesId, child);
        }
      }
    },
    // Handle child check box
    toggleAll(item, parents) {
      if (item.child) {
        for (const child of item.child) {
          this.toggleChild(item, child);
        }
      }
      if (parents) {
        for (const parent of parents) {
          this.toggleParent(parent);
        }
        this._forceUpdate();
      }
    },
    // Handle parent checkbox
    toggleParent(parent) {
      if (parent.child) {
        let isChecked = true;
        if (parent.child.filter(role => role.checked).length == 0) {
          isChecked = false;
        }
        parent.checked = isChecked;
      }
    },
    toggleChild(parent, child) {
      child.checked = parent.checked;
      if (child.child) {
        for (const grandChild of child.child) {
          this.toggleChild(child, grandChild);
        }
      }
    },
    // Convert role
    convertRole(roles) {
      this.roles = [];
      // Filter all root roles
      const rootRoles = roles
        .filter(role => role.parentId === 0)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      this.roles = this.roles.concat(rootRoles);
      // For each root role, find all child role, add to child list, recursive until no more role found
      for (let role of this.roles) {
        role.child = this.filterChildRoles(role.id, roles);
      }
    },
    // Filter child role
    filterChildRoles(parentId, roles) {
      // End recursive condition
      if (!parentId || parentId === 0 || !roles || roles.length === 0) {
        return [];
      }
      let filterRoles = roles
        .filter(role => role.parentId === parentId)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      for (let role of filterRoles) {
        // recursive recursive recursive ...
        role.child = this.filterChildRoles(role.id, roles);
      }
      return filterRoles;
    },
    // Get checked role
    getCheckedRoles(roleList, role) {
      roleList.push(role);
      if (role.child) {
        for (let child of role.child) {
          this.getCheckedRoles(roleList, child);
        }
      }
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Get all available role
    async getAllRole() {
      return await service.getAllFunction().then(res => {
        if (res.responseCode === 0) {
          this.convertRole(res.data);
          // console.log(this.roles);
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get all user group
    async searchGroupByName(name) {
      return await service.getAllActiveUserGroup({ name: name }).then(res => {
        if (res.responseCode === 0) {
          this.listGroup = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get user group detail
    async getGroupDetail(id) {
      return await service.getUserGroupDetail(id).then(res => {
        if (res.responseCode === 0) {
          this.selectedUserGroup = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get user detail
    async getUserDetail(username) {
      return await service.getUserDetail(username).then(res => {
        if (res.responseCode === 0) {
          this.data = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get user role
    async getUserRole(username) {
      return await service.getUserFunction(username).then(res => {
        if (res.responseCode === 0) {
          this.currentUserRole = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Load current user group roles
    async getCurrentUserGroupRole() {
      if (!this.selectedUserGroup || !this.selectedUserGroup.id) {
        return;
      }
      return await service
        .getUserGroupFunction(this.selectedUserGroup.id)
        .then(res => {
          if (res.responseCode === 0) {
            this.currentUserGroupRole = res.data;
            // Checked and disable roles from user group
            const disabledRolesId = this.currentUserGroupRole.map(
              role => role.id
            );
            for (let role of this.roles) {
              this.disableRole(disabledRolesId, role);
            }
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });
    },
    remoteFilterUserGroup(event) {
      this.searchGroupByName(event.target.value);
    },
    // Validate user
    validateUser() {
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      if (!isValid) return false;
      // Check user group
      if (!this.selectedUserGroup) {
        const errorMessage = this.$t("_VALIDATE.REQUIRED");
        this.error.userGroup.error = true;
        this.error.userGroup.message = errorMessage;
        _alert(null, errorMessage, false);
        return;
      }
      if (!this.isEdit) {
        // Create
        this.createUser();
      } else {
        // Update
        this.updateUser();
      }
    },
    // Create user
    createUser() {
      let temp = {
        userName: this.data.userName,
        fullName: this.data.fullName,
        gender: this.data.gender,
        phoneNumber: this.data.phoneNumber,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address,
        userGroupId: this.selectedUserGroup.id,
        owner: this.data.owner,
        active: this.data.active
      };
      this.isLoading = true;
      service
        .createUser(temp)
        .then(res => {
          if (res.responseCode === 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
            // Set userName
            this.data.userName = res.data;
            // Switch to tab role
            this.loadTabRole();
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Update user
    updateUser() {
      let temp = {
        userName: this.data.userName,
        fullName: this.data.fullName,
        gender: this.data.gender,
        phoneNumber: this.data.phoneNumber,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address,
        userGroupId: this.selectedUserGroup.id,
        owner: this.data.owner,
        active: this.data.active
      };
      this.isLoading = true;
      service
        .updateUser(temp)
        .then(res => {
          if (res) {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Update user group role
    updateUserRole() {
      let flatRole = [];
      for (let role of this.roles) {
        this.getCheckedRoles(flatRole, role);
      }
      const checkedRole = flatRole
        .filter(role => role.checked)
        .map(role => role.id);
      let temp = {
        username: this.data.userName,
        funcId: checkedRole
      };
      this.isLoading = true;
      service
        .updateUserFunction(temp)
        .then(res => {
          if (res.responseCode === 0 && !this.isEdit) {
            this.back();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    // load tab rolw
    loadTabRole() {
      this.tabs[1].disabled = false;
      this.currentTabIndex = this.tabs[1].index;
    },
    _forceUpdate() {
      this.$forceUpdate();
    }
  }
};
</script>